import { useSelector } from 'react-redux';
import { selectSiteUrl } from 'core/selectors/app';
import { encodeQueryString } from 'core/utils/helpers/url';
import { useGetBrandId } from './useGetBrandId';

export const usePrepareUnsubscribeUrl = (data) => {
  const brandId = useGetBrandId();
  const siteUrl = useSelector(selectSiteUrl);

  const prepareUnsubscribeUrl = (additionalParams = {}) => {
    const paramsString = encodeQueryString({
      ues: data.stream,
      uid: data.memberIdParam,
      bid: brandId,
      ...additionalParams,
    });

    return `${siteUrl}/unsubscribe/eu____.htm?${paramsString}`;
  };

  return prepareUnsubscribeUrl;
};
